import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import AddCourse from './dialogs/AddCourseDialog';
import { setListCourse } from './actions/courseActions';


/**
 * Function to present the filters and search the pricing plans by the filters
 * @param {*} props
 * @returns
 */
function FilterCourse(props) {
  const { classes } = props;
  const endpoint = 'http://127.0.0.1:8000/api';
  const [statusButtonAdd, setStatusButtonAdd] = useState(false);
  const dispatch = useDispatch();
 
  /**
  * Method to set the list pricing plans
  */
  const getAllCourses = async() => {
    const response = await axios.get(endpoint+'/courses');
    dispatch(setListCourse(response.data));
    return response.data;
  };
  /**
  * Methods for the add dialog
  */
  const insertCourse = () => {
    setStatusButtonAdd(true);
  };
  const handleCloseButtonAdd = () => {
    setStatusButtonAdd(false);
  };

  /**
   * Retrieve pricing plan list
   */
  useEffect(() => {
    getAllCourses();  
  }, []);
  
  return (
    <div style={{textAlign:"left"}}>
          <Button  id="insertCourse" variant="contained" style={{backgroundColor: "#ffdf40", color: "#FFFFFF"}} onClick={insertCourse} >Ingresar Curso</Button>
          <AddCourse openStatus={statusButtonAdd} onClosed= {handleCloseButtonAdd}/>
          <br/>  <br/>
        </div>
  );
}

FilterCourse.propTypes = {
  dataCourse: PropTypes.string,
};

FilterCourse.defaultProps = {
  dataCourse: "true"
};

export default FilterCourse
